import { getFormattedBalance } from '../../../../elements/BalanceCell/utils/getFormattedBalance'
import { PeriodValue } from '../../../../types/inputTypes'
import { GenericTableRow } from '../../../../utils/buildTableData'
import { BalanceSheetTableBalance } from '../types/tableTypes'

export const getHeaderRow = (periods: PeriodValue[]): string[] => [
  '', // First empty cell for the row
  ...periods.map((period) => period.label),
]

export const getRowData = (row: GenericTableRow<BalanceSheetTableBalance>, periods: PeriodValue[]): string[] => [
  row.label,
  ...periods.map((period) => {
    const periodData = row.balances.find((balance) => balance.period === period.key)
    const balance = periodData?.balance || 0

    return getFormattedBalance(balance, false)
  }),
]
